import axios from 'axios';

import { API_URL, API_REQUEST_TIMEOUT } from "../utils/Constants";
import { IAuthentication, UserRole } from '../interfaces/authentication';
import { StateLoader } from '../redux/StateLoader';
import { t } from 'i18next';
import JSZip from 'jszip';
import { Toast } from 'primereact/toast';

export interface IResponse {
    data: string,
    status: number,
    statusText: string,
    dateTime: string
}

// Create a toast reference that can be used globally
let toastRef: any = null;

// Add function to set toast reference
export const setToastRef = (ref: any) => {
    toastRef = ref;
};

//TODO: AdminID: id redux

axios.defaults.baseURL = API_URL;
axios.defaults.timeout = API_REQUEST_TIMEOUT;
//axios.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
//axios.defaults.headers = { 'Content-Type': 'application/json; charset=utf-8' };
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.common["Access-Control-Allow-Headers"] = "Origin, X-Requested-With, Content-Type, Accept";

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        let res: IResponse = {} as IResponse;
        res.dateTime = error.response.headers['server-date'];
        res.data = error.response.data;
        res.status = error.response.status;
        res.statusText = error.response.statusText;

        if (res.status === 401) {
            loader.removeAuthLoader();
        }
        else if (res.status === 450) {
            toastRef?.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error450'),
                life: 3000
            });
            throw res;
        }

        return Promise.reject(res);
    }
);

const loader = new StateLoader();
const authInfo: IAuthentication = loader.loadAuthState()

class HTTPService {
    // static API_URL: any = API_URL;

    static LOGIN = (URL: string, data: object = {}) => {
        return axios
            .post(URL, data)
            .then((result) => {
                return result;
            })
            .catch((error) => {
                return error.response || error;
            });
    }

    static GET = (URL: string, query: object = {}) => {
        query = query || {};
        return axios
            .get(URL, {
                params: query,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                return result;
            })
            .catch((error) => {
                return error;
            });
    }

    static GETBlob = (URL: string, query?: Object) => {


        return axios
            .get(URL, {
                params: query,
                responseType: 'blob',
                headers: {
                    //"responseType":"blob",
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((response) => {
                if (response.status === 200) {
                    return response.data.arrayBuffer().then((buffer) => {
                        ;

                        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'template.xlsx');
                        document.body.appendChild(link);
                        link.click();


                        let resp: IResponse = {} as IResponse;
                        resp.status = 200;
                        resp.data = ("OK")
                        return resp;
                    })
                        .catch((responses) => {
                            console.error(responses)
                            throw responses;
                        });;

                }
                else {
                    console.error(response)
                    return response;
                }

            })
            .catch((res) => {
                console.error(res)
                return res;
            });
    }
    static GETUserNames = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/User/allUserName?companyId=${companyId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }
    static GETCompanyNames = async () => {
        if (authInfo.role != UserRole.AltisAdmin) {
            return [];
        }
        let tmp = [];
        await axios
            .get(`/Company/ALLCompanyName`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }

    static GETDebitNames = async () => {
        if (authInfo.role != UserRole.AltisAdmin) {
            return [];
        }
        let tmp = [];
        await axios
            .get(`/Company/AllCompanyNames`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }

    static GETCategoryNames = async () => {
        if (authInfo.role != UserRole.AltisAdmin) {
            return [];
        }
        let tmp = [];
        await axios
            .get(`/Category/allCategoryName`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }

    static GETCategoryByCompany = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/Category/allCategoryNameByCompany?companyId=${companyId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }


    static GETDepartmentNames = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/Department/allDepartmentName?companyId=${companyId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }

    static GETBrandNames = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/Brand/allBrandName?companyId=${companyId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }

    static GETActivityNames = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/Activity/allActivityName?companyId=${companyId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }

    static GETTypeNames = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/Type/allTypeName?companyId=${companyId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }


    static GETTypeNamesByCategory = async (categoryId: string) => {
        let tmp = [];
        await axios
            .get(`/Type/allTypeNameByCategory?categoryId=${categoryId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }



    static GETSupplierNames = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/Supplier/allSupplierName?companyId=${companyId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }
    static GETSupplierNamesByCompany = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/Supplier/allSupplierNameByCompany?companyId=${companyId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }


    static GETallLocationNameByCampus = async () => {
        let tmp = [];
        await axios
            .get(`/Location/allLocationNameByCampus`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }

    static GETCampusNames = async () => {
        let tmp = [];
        await axios
            .get(`/Campus/allCampusName`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }

    static GETAllLocationNameByCampus = async (campusId: string) => {
        let tmp = [];
        await axios
            .get(`/Location/allLocationNameByCampus?campusId=${campusId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }

    static GETAllLocationNames = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/Location/allLocationName?companyId=${companyId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }


    static GETAllLocationsNames = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/Location/allLocationNames?companyId=${companyId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }

    static GETAllInventorStatusName = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/InventoryStatus/allInventoryStatusName?campusId=${companyId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }


    static GETUsersByCompany = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/User/allUserName`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }

    static GETCampusByCompany = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/Campus/allCampusNameByCompany?companyId=${companyId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }

    static GETCampusesByCompany = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/Campus/allCampusNamesByCompany?companyId=${companyId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }


    static GETInventoryStatusNames = async (companyId: number) => {
        let tmp = [];
        await axios
            .get(`/InventoryStatus/allInventoryStatusName?companyId=${companyId}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                if (result.status === 200) {
                    tmp = result.data;
                }
                else {
                    console.error(result)
                }
            })
            .catch((response) => {
                console.error(response)
            });
        return tmp;
    }

    static POST = (URL: string, data: Object, query?: Object, timeout?: number) => {
        return axios
            .post(URL, data, {
                params: query,
                timeout: timeout,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            })
            .then((result) => {
                return result;
            })
            .catch((error) => {
                return error;
            });
    }

    static async POSTBlob(URL: string, data: Object, query?: Object) {
        try {
            //await new Promise(resolve => setTimeout(resolve, 30000));

            const response = await axios.post(URL, data, {
                params: query,
                responseType: 'blob',
                headers: {
                    'Access-Control-Allow-Origin': '*', // Adjust based on your CORS setup
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                }
            });


            if (response.status === 400) {
                console.warn('Received empty or invalid response data');
                return []; // Return an empty array if no data
            }

            const blob = await response.data;
            const arrayBuffer = await blob.arrayBuffer();

            const zip = await JSZip.loadAsync(arrayBuffer);
            const imageFiles = Object.keys(zip.files).filter(filename => !zip.files[filename].dir);

            const imagePromises = imageFiles.map(async (filename) => {
                try {
                    const file = zip.files[filename];
                    const imageData = await file.async("base64");
                    return {
                        name: filename,
                        src: `data:image/png;base64,${imageData}`
                    };
                } catch (error) {
                    console.error(`Error processing file ${filename}:`, error);
                    return null;
                }
            });

            const images = (await Promise.all(imagePromises)).filter(image => image !== null);
            return images;
        } catch (error) {
            console.error('Error fetching or processing ZIP:', error);
            return [];
        }
    }

    static async POSTblob(URL: string, data: Object, query?: Object) {
        return axios.post(URL, data, {
            params: query,
            responseType: 'blob',
            headers: {
                'Access-Control-Allow-Origin': '*',
                "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                "Access-Control-Allow-Credentials": "true",
                "Authorization": authInfo?.token
            }
        })
            .then((result) => {
                if (result.status !== 200) {
                    console.warn('İndirme başarısız:', result.status);
                    return result;
                }

                const blob = result.data;
                const contentType = result.headers['content-type'];

                let fileExtension = '.bin';
                switch (contentType) {
                    case 'application/pdf':
                        fileExtension = '.pdf';
                        break;
                    case 'application/msword':
                        fileExtension = '.doc';
                        break;
                    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                        fileExtension = '.docx';
                        break;
                    case 'image/jpeg':
                    case 'image/jpg':
                        fileExtension = '.jpg';
                        break;
                    case 'image/png':
                        fileExtension = '.png';
                        break;
                    case 'image/gif':
                        fileExtension = '.gif';
                        break;
                }

                let fileName = 'downloaded' + fileExtension;
                const contentDisposition = result.headers['content-disposition'];
                if (contentDisposition) {
                    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();

                window.URL.revokeObjectURL(url);
                link.parentNode?.removeChild(link);

                return result;
            })
            .catch((error) => {
                console.error('Dosya indirme hatası:', error);
                return error;
            });
    }

    static async POSTblobExcel(URL: string, data: Object, query?: Object) {
        return axios.post(URL, data, {
            params: query,
            responseType: 'blob', // Blob türünde veri beklediğimizi belirtiyoruz
            headers: {
                'Access-Control-Allow-Origin': '*', // CORS başlıkları (gerekiyorsa ayarlayın)
                "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                "Access-Control-Allow-Credentials": "true",
                "Authorization": authInfo?.token // Yetkilendirme başlığı
            }
        })
            .then((result) => {

                // Yanıtın status kodunu kontrol edin
                if (result.status != 200) {
                    console.warn('Request failed with status:', result.status);
                    return result;
                }

                // Blob nesnesini al
                const blob = result.data;

                // Blob'u bir URL'ye dönüştür
                const url = window.URL.createObjectURL(blob);

                // Kullanıcıya indirme bağlantısını sun
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'report.xlsx'); // İndirilecek dosyanın adı
                document.body.appendChild(link);
                link.click();

                // Bağlantıyı temizle
                link.parentNode.removeChild(link);
                return result;
            })
            .catch((error) => {
                console.error('Error fetching or processing PDF:', error);
                return error;
            });
    }

    static async POSTblobExcelZip(URL: string, data: Object, query?: Object) {
        return axios.post(URL, data, {
            params: query,
            responseType: 'blob',
            headers: {
                'Access-Control-Allow-Origin': '*',
                "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                "Access-Control-Allow-Credentials": "true",
                "Authorization": authInfo?.token
            }
        })
            .then(async (result) => {
                if (result.status !== 200) {
                    console.warn('Request failed with status:', result.status);
                    return result;
                }

                try {
                    const zip = await JSZip.loadAsync(result.data);

                    const files = Object.values(zip.files).filter(file =>
                        !file.dir && (file.name.endsWith('.xlsx') || file.name.endsWith('.xls'))
                    );

                    for (const file of files) {
                        const content = await file.async('blob');

                        const url = window.URL.createObjectURL(content);

                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', file.name);
                        document.body.appendChild(link);

                        link.click();

                        link.parentNode?.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    }

                    return result;
                } catch (error) {
                    console.error('Error extracting ZIP:', error);
                    throw error;
                }
            })
            .catch((error) => {
                console.error('Error downloading files:', error);
                return error;
            });
    }

    static PUT = (URL: string, data: Object) => {
        let response: IResponse = {} as IResponse;
        return axios
            .put(URL, data, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
            }
            )
            .then((result) => {
                return result;
            })
            .catch((error) => {
                return error;
            });
    }

    static DELETE = (URL: string, body: any = null) => {
        return axios
            .delete(URL, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Credentials": "true",
                    "Authorization": authInfo?.token
                },
                data: body
            }
            )
            .then((result) => {
                return result;
            })
            .catch((error) => {
                return error;
            });

    }

}

export default HTTPService;